import { render, staticRenderFns } from "./buyCarMonthCardList.vue?vue&type=template&id=894c9854&scoped=true"
import script from "./buyCarMonthCardList.vue?vue&type=script&lang=js"
export * from "./buyCarMonthCardList.vue?vue&type=script&lang=js"
import style0 from "./buyCarMonthCardList.vue?vue&type=style&index=0&id=894c9854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894c9854",
  null
  
)

export default component.exports